export const common = {
  actions: {
    back: 'Retour',
    bookmark: 'Sauvegarder',
    cancel: 'Annuler',
    clear: 'Effacer',
    close: 'Fermer',
    copiedToClipboard: 'Copié dans le presse-papiers',
    copyToClipboard: 'Copier dans le presse-papiers',
    create: 'Créer',
    delete: 'Supprimer',
    edit: 'Modifier',
    moreInfo: 'Plus d’informations',
    openMenu: 'Ouvrir le menu',
    retry: 'Réessayer',
    revealPassword: 'Afficher le mot de passe',
    save: 'Enregistrer',
    send: 'Envoyer',
  },
  activities: {
    '1': {
      description: 'Design graphique, Illustration, Dessin animé, Design industriel, Design de marque, Direction artistique, Art 3D, …',
      label: 'Communication visuelle',
    },
    '10': {
      description: 'Réseaux sociaux',
      label: 'Création de contenu en ligne et storytelling',
    },
    '11': {
      label: 'Autre',
    },
    '2': {
      description: 'Webdesign, UI/UX, …',
      label: 'Design digital',
    },
    '3': {
      description: 'Photographie, post-production, …',
      label: 'Photographie',
    },
    '4': {
      description: 'Vidéographie, Montage, Voix off, Motion design, Sound design, …',
      label: 'Audiovisuel',
    },
    '5': {
      description: 'Copywriting, Traduction, Rédaction, …',
      label: 'Langue et communication',
    },
    '6': {
      description: 'Développement informatique, Développement web, Développement de jeux, …',
      label: 'Développement informatique',
    },
    '7': {
      description: 'Cours, Workshop, …',
      label: 'Formation',
    },
    '8': {
      description: 'Mannequin, Présentateur, Acteur, …',
      label: 'Artiste de scène',
    },
    '9': {
      description: 'Stylisme, Stylisme culinaire, Architecture d’intérieur, …',
      label: 'Stylisme et intérieur',
    },
  },
  add: 'Ajouter',
  autoSave: 'Enregistrement…',
  autoSaveLastSavedAt: {
    justNow: 'Enregistré à l’instant',
    timeAgo: 'Enregistré {{timeAgo}}',
  },
  blocker: {
    leave: 'Quitter sans enregistrer',
    stay: 'Rester sur la page',
    title: 'Quitter la page',
  },
  breadcrumb: 'Fil d’Ariane',
  breadcrumbs: {
    details: 'Détails',
    draft: 'Brouillon',
    home: 'Accueil',
  },
  colorPicker: {
    ariaLabel: 'Changer le thème de couleurs. {{ colorTheme }} est actif.',
    options: {
      'blue-orange': 'Bleu-orange',
      'bordeaux-gray': 'Bordeaux-gris',
      'green-pink': 'Vert-rose',
      'purple-yellow': 'Violet-jaune',
      'red-lightblue': 'Rouge-bleu clair',
    },
  },
  combobox: {
    removeChip: 'Supprimer {{label}}',
  },
  customAgreementOptionLabel: 'Selon le contrat-cadre',
  datatable: {
    all: 'tout',
    deleteFilter: 'Supprimer le filtre {{filter}}',
    download: 'Télécharger',
    filters: 'Filtres',
    loadingData: 'Chargement des données…',
    noData: 'Aucun résultat trouvé.',
    search: 'Rechercher',
    selection: {
      amountSelected: '{{amount}} sélectionné(s).',
      removeSelection: 'Supprimer la sélection',
      selectAll: 'Tout sélectionner',
      selectRow: 'Sélectionner la ligne',
    },
    show: 'Afficher',
    showFilters: 'Afficher les filtres',
    showResults: 'Afficher les résultats',
    sortBy: 'Trier par {{column}}',
  },
  draft: {
    defaultTitle: 'Sans titre',
    deleteModal: {
      description: 'Voulez-vous vraiment supprimer le brouillon ?',
      submit: 'Supprimer le brouillon',
      title: 'Supprimer le brouillon',
    },
  },
  error: 'Une erreur s’est produite. Contactez service@creativeshelter.be si le problème persiste.',
  errors: {
    contactSupport: 'Contactez <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> si le problème persiste.',
    fetchError: 'Aucune connexion au serveur. Vérifiez votre connexion et réessayez.',
    global: {
      text: 'Contactez <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> si le problème persiste.',
      title: 'Une erreur s’est produite',
    },
    httpErrorWithLink:
      'Une erreur s’est produite. Contactez <email href="mailto:service@creativeshelter.be">service@creativeshelter.be</email> si le problème persiste.',
    tooManyRequests: 'Surcharge ! Trop de tentatives. Patientez un instant et réessayez.',
    unknown: 'Une erreur inattendue s’est produite.',
  },
  export: 'Exporter',
  fields: {
    datePicker: {
      label: 'Date',
      openCalendar: 'Ouvrir le calendrier',
    },
    numberInput: {
      decrement: 'Diminuer la valeur',
      increment: 'Augmenter la valeur',
    },
    prefixAriaLabel: 'Ce champ a un préfixe « {{prefix}} ». Vous ne devez plus le saisir vous-même.',
    select: {
      multipleValuesAriaLabel: '{{ count }} éléments sélectionnés',
    },
    suffixAriaLabel: 'Ce champ a un suffixe « {{suffix}} ». Vous ne devez plus le saisir vous-même.',
  },
  fileUpload: {
    avatarPrompt: '<browse>Cliquez pour choisir une photo</browse> ou glissez votre photo ici',
    dropTarget: 'Déposez vos fichiers ici',
    error: 'Le téléversement du fichier a échoué.',
    filePrompt: '<browse>Cliquez pour ajouter un fichier</browse> ou glissez votre fichier ici',
    maxSize: 'max. {{max}} Mo',
    rejectedSize: '{{name}} dépasse {{max}} Mo.',
    rejectedType: 'Le type de fichier de {{name}} n’est pas pris en charge.',
    remove: 'Supprimer le fichier',
    retry: 'Réessayer',
    unnamedFile: 'Fichier',
    uploading: 'Téléversement',
    view: 'Voir le fichier',
  },
  greetings: {
    common: 'Bonjour',
    evening: 'Bonsoir',
    morning: 'Bonjour',
    noon: 'Bonjour',
  },
  impersonationBanner: {
    description: 'Les actions que vous effectuez ici sont enregistrées comme si cet utilisateur les effectuait lui-même.',
    stop: 'Arrêter l’usurpation',
    title: 'Vous consultez le compte de {{name}}',
  },
  infiniteScroll: {
    scrollToTop: 'Retour en haut',
    showMore: 'Afficher plus',
  },
  languageSelector: 'Ouvrir le sélecteur de langue, {{value}} est sélectionné',
  languages: {
    en: 'Anglais',
    fr: 'Français',
    nl: 'Néerlandais',
  },
  languagesShort: {
    en: 'EN',
    fr: 'FR',
    nl: 'NL',
  },
  listbox: {
    noOptions: 'Aucun résultat',
    noResults: 'Aucun résultat',
    search: 'Rechercher…',
  },
  loading: 'Chargement des données…',
  maintenance: {
    description:
      'Nous effectuons une petite intervention sur la plateforme, mais nous serons vite de retour pour que vous ne nous regrettiez pas trop longtemps.',
    title: 'Absents un instant, mais vite de retour !',
  },
  menu: {
    documents: 'Documents',
    invitations: 'Invitations',
    logout: 'Se déconnecter',
    pricing: 'Votre commission',
    settings: 'Paramètres',
  },
  models: {
    quotation: 'Devis',
  },
  navigation: {
    main: 'Navigation principale',
    menu: 'Menu',
    shortcuts: 'Navigation rapide',
  },
  ok: 'OK',
  optionalInput: '(facultatif)',
  or: 'ou',
  pagination: {
    label: 'Navigation entre les pages',
    next: 'Page suivante',
    pageSize: 'Nombre de résultats par page',
    previous: 'Page précédente',
  },
  pdfPreview: {
    download: 'Télécharger le PDF',
    fallback: 'Votre navigateur ne peut pas afficher ce PDF.',
  },
  placeholders: {
    file: 'Choisissez votre fichier',
    select: 'Sélectionner',
  },
  richText: {
    errors: {
      render: 'Une erreur s’est produite lors du chargement du contenu.',
    },
    linkModal: {
      editTitle: 'Modifier le lien',
      label: 'Lien',
      textLabel: 'Texte',
      title: 'Saisissez un lien',
    },
    toolbar: {
      bold: 'Gras',
      bulletList: 'Liste à puces',
      editLink: 'Modifier le lien',
      groups: {
        formatting: 'Mise en forme',
        history: 'Historique',
        lists: 'Listes',
        shortcodes: 'Ajouter un shortcode',
      },
      italic: 'Italique',
      link: 'Ajouter un lien',
      orderedList: 'Liste numérotée',
      redo: 'Rétablir',
      shortcodes: 'Ajouter un shortcode',
      underline: 'Souligner',
      undo: 'Annuler',
      unlink: 'Supprimer le lien',
    },
  },
  save: 'Enregistrer',
  saved: 'Enregistré',
  send: 'Envoyer',
  sidebar: {
    clients: 'Clients',
    community: 'Réseau',
    dashboard: 'Tableau de bord',
    expandMenu: 'Déplier le menu',
    forum: 'Forum',
    groupInvoicing: 'Facturation',
    groupSocial: 'Community',
    help: 'Aide',
    invite: 'Inviter des amis',
    invoices: 'Factures',
    jobPosts: 'Missions',
    minimalizeMenu: 'Replier le menu',
    more: 'Plus',
    products: 'Produits',
    quotations: 'Devis',
  },
  status: {
    completed: 'Terminé',
    upcoming: 'À faire',
  },
  timeline: {
    ariaLabel: 'Chronologie',
  },
  topbar: {
    activePremiumForFree_one: 'Dernier jour de facturation gratuite',
    activePremiumForFree_other: 'Encore {{count}} jours de facturation gratuite',
    dropdown: {
      commission: 'Votre commission',
      documents: 'Documents',
      invitations: 'Invitations',
      logout: 'Se déconnecter',
      settings: 'Paramètres',
    },
  },
};
